import React from "react";

import nth0WithSup from "@/modules/nth0WithSup";
import { assetImg } from "@/modules/moduleImporter";
import { IMachineGameResultHistoryProps } from "@/types/GameHistoryTypes";

import "../m29/index.scss";

import Nnary from "@/modules/Nnary";
import M26 from "../m26";
import { isMobile } from "@/modules/commonMobile";

/**
 * Copied from M26
 */
export default class M42 extends React.Component<IMachineGameResultHistoryProps> {
	private getReversedHistory() {
		return this.props.history.slice(0).reverse().slice(0, 9);
	}

	private getPlainHistoryPairs() {
		return this.getReversedHistory().map(item => item.angka.split(","));
	}

	/**
	 * Pass this in array iterators
	 */
	private getAssetImg(name: string, idx: number) {
		return assetImg("m42", name, `GRH_m42_${idx}`);
	}

	// private verticalHistoryFragment() {
	// 	const pairs = this.getPlainHistoryPairs();

	// 	return (
	// 		<div className="history-container m42-history">
	// 			{
	// 				pairs.map((pair, idx) =>
	// 					<div className="row" key={`GRH_m42_${idx}`}>
	// 						{
	// 							pair.map((num, _idx) => this.getAssetImg(num, _idx))
	// 						}
	// 					</div>
	// 				)
	// 			}
	// 		</div>
	// 	);
	// }

	private horizontalHistoryFragment() {
		const
			pairs = this.getPlainHistoryPairs(),
			first = pairs.map(item => item[0]),
			second = pairs.map(item => item[1]);

		return (
			<div className="history-container m42-history">
				<div className="row">
					{nth0WithSup(0)}

					{first.map((num, idx) => this.getAssetImg(num, idx))}
				</div>

				<div className="row">
					{nth0WithSup(1)}

					{second.map((num, idx) => this.getAssetImg(num, idx))}
				</div>
			</div>
		);
	}

	render() {
		const { type } = this.props;

		// console.log("Mobile?" + isMobile());

		if (type === "ticket")
			return <M26 {...this.props} />;

		// if (!isMobile())
		// 	return this.verticalHistoryFragment();

		return this.horizontalHistoryFragment();
	}
}